// extracted by mini-css-extract-plugin
export default {"disclaimer":"Mkf77lx"};